export class RequestToAgreeTariffTimeSchedule {
    requestToAgreeTariffId: number;
    timeScheduleId: number;
}